/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ComponentState } from './component-state';

/**
 * 
 * @export
 * @interface StatusResponse
 */
export interface StatusResponse {
    /**
     * 
     * @type {string}
     * @memberof StatusResponse
     */
    'overall': StatusResponseOverallEnum;
    /**
     * ISO-8601 момент последнего успешного опроса
     * @type {string}
     * @memberof StatusResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {Array<ComponentState>}
     * @memberof StatusResponse
     */
    'components': Array<ComponentState>;
}

export const StatusResponseOverallEnum = {
    Operational: 'OPERATIONAL',
    Degraded: 'DEGRADED',
    Down: 'DOWN',
    Unknown: 'UNKNOWN'
} as const;

export type StatusResponseOverallEnum = typeof StatusResponseOverallEnum[keyof typeof StatusResponseOverallEnum];


